import type { Dispatch, FC, SetStateAction } from 'react';
import { StyledBurgerButton } from './burger-button.styles';

type Props = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

export const BurgerButton: FC<Props> = (props) => {
  const { open, setOpen } = props;
  const handleClick = () => {
    setOpen((prevState) => !prevState);
  };

  return (
    <StyledBurgerButton $open={open} onClick={handleClick}>
      <div />
      <div />
      <div />
    </StyledBurgerButton>
  );
};
